import { taxonomyTypes } from './constants'

export const getTaxonomyTypeOptions = (availableTaxonomyTypes, t) => {
  return taxonomyTypes
    .filter(option => availableTaxonomyTypes?.includes(option.value))
    .map(option => ({ ...option, label: t(option.label) }))
}
